'use client'

import cn from 'clsx'
import { useRect, useWindowSize } from 'hamo'
import { Image } from '~/components/image'
import { Marquee } from '~/components/marquee'
import { useScrollTrigger } from '~/hooks/use-scroll-trigger'
import { useStore } from '~/libs/store'
import { CloudCard } from './card'
import s from './clouds.module.css'

const data = [
  {
    _uid: 'fcbf8973-0c32-4ac7-bd06-5a1a325a4e5b',
    media: {
      filename: '/images/people/brettdashevsky.jpg',
    },
    logo: {
      filename: '/images/logos/creatoreconomy.png',
      alt: 'Creator Economy',
    },
    name: 'Brett Dashevsky',
    text: `I deleted  Cora just to feel the difference it makes. And the difference was felt. Scrambling to connect my emails to it again.`,
    position: 'Founder at',
  },
  {
    _uid: 'ae0df41a-8b4d-4c47-9856-cc3f60dd9eb8',
    media: {
      filename: '/images/people/andrewwilkinson.jpg',
    },
    logo: {
      filename: '/images/logos/tiny.png',
      alt: 'tiny',
    },
    name: 'Andrew Wilkinson',
    text: `I've tried all these newfangled AI email apps, and the winner, by far, is Cora by Every`,
    position: 'Founder at',
  },
  {
    _uid: '0d7b8e48-0c14-47f9-bae0-8a0d2c7c79ec',
    media: {
      filename: '/images/people/mikekrieger.jpg',
    },
    logo: {
      filename: '/images/logos/anthropic.png',
      alt: 'Anthropic',
    },
    name: 'Mike Krieger',
    text: `I’ve been really enjoying Cora by Every...this morning was a record; it handled / categorized every single email I received, left me with inbox zero and a nice Brief to read instead.`,
    position: 'CPO at',
  },
  {
    _uid: '13c512e0-d36f-4702-a296-e12b33a41c95',
    media: {
      filename: '/images/people/dannyaziz.png',
    },
    logo: {
      filename: '/images/logos/spiral.png',
      alt: 'Spiral',
    },
    name: 'Danny Aziz',
    text: `I've been using Cora for a few months now. I'm at inbox zero pretty much all the time and I'm replying to the important emails at record speed`,
    position: 'Founder of',
  },
  {
    _uid: 'd7e6ce1f-10ff-4303-85e7-4c7a9f2f1161',
    media: {
      filename: '/images/people/jimraptis.jpg',
    },
    logo: {
      filename: '/images/logos/magicpattern.png',
      alt: 'Magic Pattern',
    },

    name: 'Jim Raptis',
    text: `Storytelling and design on steroids \n→ cora.computer`,
    position: 'GM of',
  },
  {
    _uid: 'e4bfa6ea-e97e-4f52-b1e6-5c58c9dfe96d',
    media: {
      filename: '/images/people/mitchellbaldridge.jpg',
    },
    logo: {
      filename: '/images/logos/recostseg.png',
      alt: 'Re cost seg',
    },
    name: 'Mitchell Baldridge',
    text: `Using Cora for the last month has changed the way I deal with email`,
    position: 'Founder of',
  },
  {
    _uid: '1',
    media: {
      filename: '/images/people/aodhanmoran.jpg',
    },
    logo: {
      filename: '/images/logos/castcraft.png',
      alt: 'Castcraft co.',
    },
    name: 'Aodhán Moran',
    text: `Been in since release, I have opened every single summary. Still feels like magic`,
    position: 'Cofounder of',
  },
]

export function Clouds({ className }) {
  const [setRectRef, rect] = useRect()

  const setIsCloudsOverNav = useStore((state) => state.setIsCloudsOverNav)

  const { height: windowHeight } = useWindowSize()

  useScrollTrigger(
    {
      rect,
      start: `top 95`,
      end: 'bottom top',
      onEnter: () => {
        setIsCloudsOverNav(true)
      },
      onLeave: () => {
        setIsCloudsOverNav(false)
      },
    },
    [windowHeight]
  )

  return (
    <section
      className={cn(
        'relative h-fit w-full flex items-center justify-center -dr-mt-80 -dt:dr-mt-66 dr-mb-80 overflow-x-clip',
        className
      )}
      ref={setRectRef}
    >
      {/* CLOUDS */}
      <Image
        src="/images/cloud.webp"
        alt="clouds"
        className="!w-full absolute dt:top-[-25%] transform-[scale(1.5)] top-[-10%]"
      />
      <Image
        src="/images/cloud.webp"
        alt="clouds"
        className="!w-full absolute dt:bottom-[-10%] bottom-0  transform-[scale(1.5)]"
      />

      {/* CONTENT */}
      <div
        className={cn(
          s.wrapper,
          'relative h-fit w-full flex items-center dr-py-40 dt:dr-py-100 overflow-x-clip'
        )}
      >
        <Marquee repeat={10} speed={0.5}>
          {data?.map((card) => (
            <CloudCard key={card?._uid} data={card} />
          ))}
        </Marquee>
      </div>
    </section>
  )
}
